<svg:circle class="no-events" />
<svg:text class="no-events">{{ count }}</svg:text>
